var t, s;
function r() {
  if (s) return t;
  s = 1;
  return t = class {
    constructor(t, s, r, e) {
      this.city = t, this.state = s, this.zipCode = r, this.inputId = e, this.result = [], this.customParameters = {};
    }
    addCustomParameter(t, s) {
      this.customParameters[t] = s;
    }
  };
}
export { r as __require };